export default {"src":"/_next/static/media/cog.ee754438.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};